import { gql } from "@apollo/client";

export const GET_USUARIOS_PAGINADOS = gql`
query getAllUsuarios (
    $skip: Int
    $take: Int
    $where: t_SegUsuarioFilterInput
    $order: [t_SegUsuarioSortInput!]
) {
    allUsuarios (skip: $skip, take: $take, where: $where, order: $order)
        {
            items {
                idUsuario,
                usuario,
                clave,
                nombre,
                apellido,
                email,
                idUsuarioAuth,
                activo,
                t_SecUsuarioDelegacion{
                    idDelegacion
                }
                idDelegacion
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
}`;

export const adaptUsuariosParsedByTipoArray = (usuariosData) => {
  return structuredClone(usuariosData)?.
  map((usuario) => usuario) || [];
};

const adaptUsuariosByTipoArray = (usuariosData) => {
  return structuredClone(usuariosData?.allUsuarios?.items)?.
  map((usuario) => usuario) || [];
};

export default adaptUsuariosByTipoArray;